module.exports = __webpack_public_path__ + "static/6-46f1b10bd4a8cd876c32dfb2f3deba19.png";